import { render, staticRenderFns } from "./tier_badge_popover.vue?vue&type=template&id=1b921cea"
import script from "./tier_badge_popover.vue?vue&type=script&lang=js"
export * from "./tier_badge_popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports